// Configuration for calculating years of experience
export const EXPERIENCE_START_DATES = {
  // DevOps/SRE experience start date
  DEVOPS: '2019-11-04',

  // GNU/Linux systems experience start date
  LINUX: '2012-01-01',
};

/**
 * Calculate years of experience from a start date to now
 */
export const calculateYears = (startDate: string): number => {
  const start = new Date(startDate);
  const now = new Date();
  const diffTime = Math.abs(now.getTime() - start.getTime());
  const diffYears = Math.floor(diffTime / (1000 * 60 * 60 * 24 * 365.25));
  return diffYears;
};

/**
 * Get calculated years for display
 */
export const getExperienceYears = () => ({
  DEVOPS_START_DATE: calculateYears(EXPERIENCE_START_DATES.DEVOPS),
  LINUX_START_DATE: calculateYears(EXPERIENCE_START_DATES.LINUX),
});
